export default __webpack_public_path__ + "static/media/jane-churchyard-benefits-6.d597382a.jpg";